import React, { useState } from 'react';
import supportedBrowsers from './supportedBrowsers';

const CLOSE_ICON_OFFSET = 15; // center icon
const CLOSE_ICON_PADDING = 2;
const CLOSE_ICON_SIZE = 18;

// Integrated with .browserslistrc
// @see https://github.com/browserslist/browserslist-useragent-regexp
// Testing: https://developer.chrome.com/docs/devtools/device-mode/override-user-agent/
const browserSupported = supportedBrowsers.test(navigator.userAgent);

/**
 * Some rules for this file:
 * - MUST contain plain HTML/CSS only (not MUI components)
 * - AVOID branding because we can't detect vendor mode
 */
const UnsupportedBrowser: React.FC = () => {
  const [closed, setClosed] = useState(false);

  if (browserSupported || closed) {
    return <></>;
  }

  const onClose: React.MouseEventHandler<HTMLAnchorElement> = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    e.preventDefault();
    e.stopPropagation();
    setClosed(true);
  };

  return (
    <>
      <style>{`
        .UnsupportedBrowserBanner {
          background: #FFF5E5;
          border-bottom: 1px solid #CCCCCC;
          display: block;
          font-family: Arial;
          padding: 12px 40px 12px 12px;
          position: relative;
          text-align: center;
        }
        .UnsupportedBrowserBanner__close {
          box-sizing: border-box;
          color: #000;
          display: block;
          font-size: ${CLOSE_ICON_SIZE}px;
          height: ${CLOSE_ICON_SIZE + CLOSE_ICON_PADDING}px;
          line-height: ${CLOSE_ICON_SIZE}px;
          padding: ${CLOSE_ICON_PADDING}px;
          position: absolute;
          right: ${CLOSE_ICON_OFFSET}px;
          top: ${CLOSE_ICON_OFFSET}px;
          width: ${CLOSE_ICON_SIZE + CLOSE_ICON_PADDING}px;
        }
        .UnsupportedBrowserBanner__icon {
          color: #C77700;
        }
        .UnsupportedBrowserBanner__learnMore {
          margin-left: 4px;
        }
        .UnsupportedBrowserBanner__message {
          font-size: 16px;
          line-height: 24px;
        }
        @media only screen and (max-width: 816px) {
          .UnsupportedBrowserBanner {
            text-align: left;
          }
          .UnsupportedBrowserBanner__learnMore {
            display: block;
            margin-left: 0;
          }
        }
      `}</style>
      <div className="UnsupportedBrowserBanner">
        <span className="UnsupportedBrowserBanner__icon">&#9888;</span>{' '}
        <span className="UnsupportedBrowserBanner__message">
          This site works best in a newer version of your browser.
        </span>
        <a
          className="UnsupportedBrowserBanner__learnMore"
          href="https://help.mindtickle.com/support/solutions/articles/3000011220-supported-browsers-devices-and-screen-sizes#browsers-supported-for-digital-sales-rooms-dsr--0-1"
          rel="noreferrer"
          target="_blank"
        >
          Learn more about updating your browser here.
        </a>
        <a
          href="#"
          className="UnsupportedBrowserBanner__close"
          onClick={onClose}
        >
          &#10005;
        </a>
      </div>
    </>
  );
};

export default UnsupportedBrowser;
